module.exports = __webpack_public_path__ + "static/media/staff_linking.90975f99.svg";